import { render } from "./ManagePermissionsModal.vue?vue&type=template&id=78a1d83e&scoped=true"
import script from "./ManagePermissionsModal.vue?vue&type=script&lang=js"
export * from "./ManagePermissionsModal.vue?vue&type=script&lang=js"

import "./ManagePermissionsModal.vue?vue&type=style&index=0&id=78a1d83e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a1d83e"]])

export default __exports__